export enum ServiceRequestSource {
  My = 'my',
  Inbox = 'inbox',
  RequestMonitoring = 'rm',
}
